import { Component } from 'vue-property-decorator';


import { Type } from "src/utils";

/**
 * 表示一个支付方式。
 * @enum
 * @version 1.0.0
 */
enum PaymentType
{
    /**
     * 微信公众号。
     * @member
     */
    wechatJSAPI = 1,

    /**
     * 微信H5
     * @member
     */
    wechatMWEB,

    /**
     * 扫码
     * @member
     */
    wechatNATIVE,

    /**
     * App支付
     * @member
     */
    wechatAPP
}

/*
* 定义枚举元数据。
*/
Type.setMetadata(PaymentType,
{
    wechatJSAPI:
    {
        alias: "微信公众号",
        description: ""
    },
    wechatMWEB:
    {
        alias: "微信H5",
        description: ""
    },
    wechatNATIVE:
    {
        alias: "扫码支付",
        description: ""
    },
    wechatAPP:
    {
        alias: "APP支付",
        description: ""
    }
});

export default PaymentType;
